module.exports = __webpack_public_path__ + "img/logo.c47da457.png";